import Button from "@mui/material/Button";
import type { ButtonProps } from "@mui/material/Button";
import Add from "@mui/icons-material/Add";
import { filterHeaderActionSx } from "../../lib/ui/pageButtons";

/** Compact primary create control for table filter headers. */
export default function PageCreateButton({
  children,
  startIcon,
  sx,
  ...rest
}: ButtonProps) {
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      startIcon={startIcon ?? <Add sx={{ fontSize: "18px !important" }} />}
      sx={{
        ...filterHeaderActionSx,
        "& .MuiButton-startIcon": { mr: 0.5, ml: 0 },
        "& .MuiButton-startIcon > *:nth-of-type(1)": { fontSize: 18 },
        ...(sx as object),
      }}
      {...rest}
    >
      {children}
    </Button>
  );
}
